import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, Paper, Typography } from '@mui/material';
import { BRAND, brandAlpha } from '../../../theme/brandTokens';

const CustomerImportMappingTile = ({
  label,
  markerSide = 'left',
  markerColor = BRAND.accent,
  disabled = false,
  highlighted = false,
}) => {
  const marker = (
    <Box
      sx={{
        width: '4px',
        height: '39px',
        bgcolor: markerColor,
        ...(markerSide === 'left' ? { mr: 0.5 } : { ml: 0.5 }),
      }}
    />
  );

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        height: '39px',
        p: 0,
        display: 'flex',
        alignItems: 'center',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: `0 2px 16px 0 ${brandAlpha('text', 0.08)}`,
        border: highlighted ? `1px dashed ${BRAND.accent}` : `1px solid ${BRAND.line}`,
        bgcolor: BRAND.surface,
        // Drop-target tint layered over the surface so the board's dot grid does not show through.
        backgroundImage: highlighted
          ? `linear-gradient(${brandAlpha('accent', 0.08)}, ${brandAlpha('accent', 0.08)})`
          : 'none',
        cursor: disabled ? 'not-allowed' : 'grab',
        opacity: disabled ? 0.55 : 1,
      }}
    >
      {markerSide === 'left' && marker}
      <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0, px: 0.75 }}>
        <DragIndicatorIcon sx={{ color: '#9e9e9e', fontSize: 18, mr: 1 }} />
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 600,
            color: BRAND.text,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {label}
        </Typography>
      </Box>
      {markerSide === 'right' && marker}
    </Paper>
  );
};

export default CustomerImportMappingTile;
